let language = {
    "BILLING-METHOD-SAFE-DATA-TIP": `
        您的数据是安全的—我们不会存储您的卡片或支付方式详细信息，并且我们使用
        行业标准加密来保护您的个人信息。
    `,
    "BILLING-METHOD-PRESS-PAYPAL-TIP": "请按下面的黄色 Paypal 按钮授权您的账户。",
    "BILLING-METHOD-FILL-OUT-INFO-TIP": "请完成填写支付信息以选择支付方式！",
};

export { language }
